/* eslint-disable no-undef */


export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_V6_URL = process.env.REACT_APP_API_V6_URL;


// JSON API
export const LOGIN = `${API_BASE_URL}/agency/jwt/token/`;

export const ACCESS_CARD_OTP_LOGIN = `${API_V6_URL}/register/0/otp_verify_and_login_access_card/`;

export const GET_JWT = `${API_V6_URL}/parent/get-jwt/`;

export const LOGOUT = `${API_BASE_URL}/agency/jwt/logout/`;

export const REFRESH_TOKEN = `${API_BASE_URL}/agency/jwt/token/refresh/`;

export const REGISTER = `${API_V6_URL}/register/0/user_registration/`;

export const VERIFY = `${API_V6_URL}/register/0/verify_otp/`;

export const RESET_PASSWORD = `${API_V6_URL}/register/0/generate_new_otp/`;

export const VERIFY_RESET_PASSWORD = `${API_V6_URL}/register/0/verify_otp/`;

export const CHANGE_PASSWORD = `${API_V6_URL}/register/0/reset_password_with_otp/`;

export const HOME_PAGE = `${API_V6_URL}`;

export const EVENT_DATA = `${API_V6_URL}/parent/event`;

export const SPECIAL_TAGS = `${API_V6_URL}/parent/get_special_product_tags/`;

export const SPECIAL_TAGS_PHOTOS = `${API_V6_URL}/parent/get_special_tags_photos/`;

export const ACCESS_CARD = `${API_BASE_URL}/api/v6/access-card/accesses/`;

export const ORG_ACCESS_CARDS = `${API_BASE_URL}/api/v6/access-card/access_cards_all/`;

export const REMOVE_ACCESS_CARDS = `${API_BASE_URL}/api/v6/access-card/remove_access_cards/`;

export const ADDRESS_URL = `${API_V6_URL}/shipping/`;

export const PROFILE_DETAILS = `${API_V6_URL}/pixf-user/`;

export const OFFERS = `${API_V6_URL}/offers/`;

export const CART = `${API_V6_URL}/parent/cart/`;

export const EVENT_ICS = `${API_V6_URL}/access-card/get_ics_file_for_access_card`;

export const PAYBOX = `${API_V6_URL}/payments/get_payment_data/`;

export const LEMONWAY = `${API_V6_URL}/parent/lemonway/`;

export const PROCESS_PAYMENT_RESULT = `${API_V6_URL}/payments/process_payment_result/`;

export const ORDERS = `${API_V6_URL}/purchase-orders/0`;